import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const AULELO_TOKEN_KEY = "aulelo_token";

export const auleloApi = axios.create({ baseURL: `${BACKEND_URL}/api/aulelo` });

auleloApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(AULELO_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const auleloAuth = {
  saveToken(t) { localStorage.setItem(AULELO_TOKEN_KEY, t); },
  getToken() { return localStorage.getItem(AULELO_TOKEN_KEY); },
  clear() { localStorage.removeItem(AULELO_TOKEN_KEY); },
};
